import React, { useState, useEffect } from 'react';

const SplashScreen = ({ isReady }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const [hidden, setHidden] = useState(false);

  useEffect(() => {
    if (isReady) {
      setFadeOut(true);
      const timer = setTimeout(() => setHidden(true), 950);
      return () => clearTimeout(timer);
    }
  }, [isReady]);

  if (hidden) return null;

  return (
    <div
      className={`splash-screen ${fadeOut ? 'splash-fade-out' : ''}`}
      data-testid="splash-screen"
    >
      <div className="splash-grain-overlay" />

      <div className="splash-emblem">
        <img
          src="https://customer-assets.emergentagent.com/job_b94b95c1-d586-44dc-829b-05989d33f0ec/artifacts/jj6t2qbc_tusker-off-whiteAsset.png"
          alt="Tuskermark"
          style={{ width: '100%', height: '100%', objectFit: 'contain', opacity: 0, animation: 'emblemFade 1s ease forwards 0.3s' }}
        />
      </div>

      <p className="splash-tagline">A Safari Retreat</p>

      <div className="splash-loader">
        <span className="splash-loader-bar" />
        <span className="splash-loader-bar" />
        <span className="splash-loader-bar" />
        <span className="splash-loader-bar" />
        <span className="splash-loader-bar" />
      </div>
    </div>
  );
};

export default SplashScreen;
